import request from "_private/utils/request";
/**
 * @description  所有服务商信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
//获取所有审核服务商名称
export function FetchAllProvider() {
  return request({
    url: "/examine/serviceProviderInfo/findServiceProviderInfo",
    method: "post"
  });
}

/**
 * @description  已审核通过服务商信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
//获取已通过审核服务商名称
export function FetchAuditProvider() {
  return request({
    url: "/examine/serviceProviderInfo/findAllServiceProviderInfos",
    method: "post"
  });
}

/**
 * @description  获取全部企业信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
//获取全部企业信息下拉
export function FetchAllComparys() {
  return request({
    url: "/examine/comparyInfo/findAllComparys",
    method: "post"
  });
}

/**
 * @description  获取已通过企业信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
//获取已通过企业信息下拉
export function FetchAuditComparys() {
  return request({
    url: "/base/compary/findAllComparys",
    method: "post"
  });
}

/**
 * @description  获取Urgent企业信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
//获取已通过企业信息下拉
export function FetchUrgentComparys() {
    return request({
        url: "/ug/company/findAllUrgentComparys",
        method: "post"
    });
}
